import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-surface/80 via-white to-white" />
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-bl from-accentMuted/40 to-transparent rounded-full blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-10 pt-36 md:pt-44 pb-20 md:pb-28">
        <div className="animate-fade-in-up max-w-3xl">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-primary leading-tight mb-6 tracking-tight">
            チャットで伝えるだけ。
            <br />
            LPをかんたんに作って公開。
          </h1>

          <p className="text-base md:text-lg text-textMuted max-w-2xl leading-relaxed mb-10">
            ChatLP は、AIとのチャットでLPの作成・修正・公開ができるサービスです。
            デザインやコーディングの知識がなくても、事業に使えるページを形にできます。
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3">
            <Link to="/auth/sign-in?redirectTo=/app/wizard" className="app-btn-primary">
              無料で試す
            </Link>
            <a href="#how-it-works" className="app-btn-secondary">
              デモを見る
            </a>
          </div>
        </div>

        {/* Product mockup area */}
        <div className="mt-16 md:mt-20 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <div className="relative rounded-lg border border-border shadow-lg overflow-hidden bg-white">
            <div className="flex items-center gap-2 px-4 py-3 border-b border-border bg-surface">
              <div className="flex gap-1.5">
                <div className="w-2.5 h-2.5 rounded-full bg-border" />
                <div className="w-2.5 h-2.5 rounded-full bg-border" />
                <div className="w-2.5 h-2.5 rounded-full bg-border" />
              </div>
              <div className="flex-1 mx-8">
                <div className="h-5 bg-surfaceMuted rounded-sm max-w-xs mx-auto" />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/* Chat side */}
              <div className="p-6 md:p-8 border-r border-border">
                <div className="space-y-4">
                  <div className="flex justify-end">
                    <div className="bg-primary text-white text-sm px-4 py-2.5 rounded-lg rounded-tr-sm max-w-[80%]">
                      パーソナルジムのLPを作りたいです。体験予約の申込みにつなげたいです。
                    </div>
                  </div>
                  <div className="flex justify-start">
                    <div className="bg-surface text-primary text-sm px-4 py-2.5 rounded-lg rounded-tl-sm max-w-[80%]">
                      パーソナルジムのLPを作成しますね。ヒーロー、特徴、トレーナー紹介、料金、体験予約フォームの構成で進めます。
                    </div>
                  </div>
                  <div className="flex justify-end">
                    <div className="bg-primary text-white text-sm px-4 py-2.5 rounded-lg rounded-tr-sm max-w-[80%]">
                      いいですね。料金は月4回で28,000円です。
                    </div>
                  </div>
                </div>
              </div>
              {/* Preview side */}
              <div className="p-6 md:p-8 bg-surface/50">
                <div className="space-y-4">
                  <div className="h-4 bg-primary/10 rounded w-1/3" />
                  <div className="h-8 bg-primary/8 rounded w-3/4" />
                  <div className="h-3 bg-border rounded w-full" />
                  <div className="h-3 bg-border rounded w-5/6" />
                  <div className="mt-6 grid grid-cols-3 gap-3">
                    <div className="h-16 bg-border/60 rounded" />
                    <div className="h-16 bg-border/60 rounded" />
                    <div className="h-16 bg-border/60 rounded" />
                  </div>
                  <div className="mt-4 h-10 bg-primary/10 rounded w-1/3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
